
//virtualSimulation
<template>
  <div class="link-views white-bg">
  
    <div class="select-div">
      <div class="mr">
        <span>根据关键字搜索实验：</span>
        <Input clearable v-model="pageData.Search" style="width:200px"/>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="sureSearch(pageData.Search)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch('')">重置</Button>
      </div>
    </div>
    <div class="list">
      <Row :gutter="16" v-if="virtual.Result.length>0">
        <i-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="6"
          :xxl="4"
          v-for="(item,index) in virtual.Result"
          :key="index"
          class="listItem"
        >
          <Card>
            <!-- @click="intoVirtual(item.ExpID)" -->
            <div class="imgBox imgBox1" >
              <router-link :to="{name:'virtual',params:{id:item.ExpID}}">
                <img :src="port+item.ExpPicUrl">
              </router-link>
        
            </div>
            <div class="cardText">
              <Tooltip :content="item.ExpName">
                <div class="text-overflow">{{item.ExpName}}</div>
              </Tooltip>
            </div>
          </Card>
        </i-col>
      </Row>
      <div v-else class="nodata">暂无数据</div>
    </div>
    <div class="page-div">
      <Page
        show-total
        :total="virtual.records"
        :current="pageData.page"
        :page-size="pageData.size"
        @on-change="changePage"
      />
    </div>

  
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/visitor-api.js";
import myUpload from "../../../components/my-upload";
import myUploadList from "../../../components/my-upload-list";

export default {
  name: "fkvirtualSimulation",
  components: {
    myUpload: myUpload,
    myUploadList: myUploadList,

  },
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      virtual: {
        Result: []
      },
      pageData: {
        Search: "",
        page: 1,
        size: 12
      },
      editApi: "AddExperiment",
      editItem: {
        Team: []
      },
      activeName: "name1",
      ExpShowList: [],
      DecVideoUrlList: [],
      DirVideoUrlList: [],
      urlList: [],
      showProgress: false,
      percentage: 0
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.getpageArr();
  },
  watch: {},
  methods: {

    //获取所有实验列表有分页
    async getpageArr() {
      this.virtual = await homeApi.GetExperimentArr({
        Search: this.pageData.Search ? this.pageData.Search : "",
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 12
      });
      this.loading = false;
    },
 
  
    
    // 搜索
    sureSearch(Search) {
      this.pageData.Search = Search;
      this.pageData.page = 1;
      this.getpageArr();
    },
    //分页
    changePage(page) {
      // this.pageData.Search = "";
      this.pageData.page = page;
      this.getpageArr();
    },
    // intoVirtual(){},

  }
};
</script>